<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">
          Общая информация
        </h4>
      </div>
      <b-row>
        <b-col md="6">
          <span
            class="b-avatar badge-minimal badge-light-primary rounded-circle"
            style="width: 80px; height: 80px; margin-left: 20px;"
          >
            <span class="b-avatar-img">
              <img
                :src="photoUrl"
                alt="avatar"
              >
            </span>
          </span>
        </b-col>
      </b-row>

      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Имя тренера"
              >
                <b-form-input
                  v-model="trainer.name"
                  placeholder="Имя"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>
      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Фамилия тренера"
              >
                <b-form-input
                  v-model="trainer.surname"
                  placeholder="Фамилия"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>
      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Запись к тренеру"
              >
                <b-form-checkbox
                  v-model="trainer.isAcceptingRequests"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>

    <div class="card">
      <div class="card-header" />
      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <div class="upload-wrap">
                <file-uploader
                  @updatePhotos="addImage"
                />
              </div>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h4 class="card-title">
          Вид спорта
        </h4>
      </div>
      <span class="bv-no-focus-ring col-form-label pt-0 label">
        Выберите вид спорта
      </span>
      <v-select
        v-model="sportOption"
        :close-on-select="true"
        :options="sportOptions"
        :reduce="sportOption => sportOption"
        label="name"
        input-id="name"
        :value="sportOption"
        class="select"
        multiple
        @search="(search, loading) => getKindsOfSport(search, loading)"
      />
    </div>

    <div class="card">
      <div class="card-header" />
      <div class="card-body">
        <h4 class="card-title">
          Описание
        </h4>
        <div class="my-1">
          Описание
        </div>
        <quill-editor
          v-model="trainer.description"
        />
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h4 class="card-title">
          Ссылки
        </h4>
      </div>
      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Instagram"
              >
                <b-form-input
                  v-model="trainer.inst"
                  placeholder="Instagram"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="Facebook"
              >
                <b-form-input
                  v-model="trainer.facebook"
                  placeholder="Facebook"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="VK"
              >
                <b-form-input
                  v-model="trainer.vk"
                  placeholder="VK"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="Twitter"
              >
                <b-form-input
                  v-model="trainer.twitter"
                  placeholder="Twitter"
                />
              </b-form-group>
            </b-col>

          </b-row>
        </b-form>
      </div>
    </div>

    <b-col>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        type="submit"
        variant="primary"
        class="mr-1 save-button"
        :disabled="isloading"
        @click="saveItem"
      >
        <b-spinner
          v-if="isloading"
          small
        />
        {{ isloading ? 'Сохранение...' : 'Сохранить' }}
      </b-button>
    </b-col>
  </div>
</template>

<script>
import {
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BRow,
  BSpinner,
  VBPopover,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { Russian } from 'flatpickr/dist/l10n/ru'
import vSelect from 'vue-select'
import crud_module from '../../../libs/crud_module'
import FileUploader from '@/global-components/FileUploader'

const trainer_module = crud_module({
  entity_name: 'trainer',
})

const kind_of_sport_module = crud_module({
  entity_name: 'kind-of-sport',
})

export default {
  name: 'CategoryPage',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    BFormInput,
    BForm,
    BButton,
    BSpinner,
    FileUploader,
    vSelect,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  data() {
    return {
      config: {
        allowInput: true,
        altFormat: 'd.m.Y H:i',
        altInput: true,
        enableTime: true,
        dateFormat: 'Z',
        locale: Russian, // locale for this instance only
      },
      isloading: false,
      trainer: {},
      sportOptions: [],
      sportOption: null,
      photo: null,
      debounce: null,
    }
  },
  computed: {
    photoUrl() {
      if (this.photo && this.photo.fullPath) {
        return this.photo.fullPath
      }
      return ''
    },
  },
  // created: {
  //   search(search, loading) {
  //     this.$emit('search', search, loading)
  //   },
  // },
  async created() {
    await kind_of_sport_module.fetchItems()
      .then(result => {
        this.sportOptions = result.data.rows
      })

    if (this.$route.params.id === 'new') {
      return
    }
    try {
      await trainer_module.fetchItem(this.$route.params.id, {
        query: {
          admin: '1',
        },
      }).then(result => {
        this.trainer = result.data
        this.sportOption = result.data.kindOfSports
        this.photo = result.data.photo
      })
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    saveItem() {
      if (this.$route.params.id === 'new') {
        this.create()
      } else {
        this.update()
      }
    },
    addImage(image) {
      this.photo = image
      this.trainer.file_id = image.id
    },
    async update() {
      try {
        await trainer_module.updateItem(
          this.trainer.id,
          { ...this.trainer, kindOfSports: this.sportOption },
        )
          .then(response => {
            this.isloading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: 'Тренер сохранен',
                variant: 'success',
              },
            })
            this.$router.push({ name: 'trainers' })
            return response
          })
          .catch(error => {
            this.isloading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: error.response.data.message,
                variant: 'danger',
              },
            })
          })
      } catch (e) {
        this.isloading = false
        console.error(e)
      }
    },
    async create() {
      try {
        await trainer_module.createItem({ ...this.trainer, kindOfSports: this.sportOption })
          .then(response => {
            this.isloading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: 'Тренер добавлен',
                variant: 'success',
              },
            })
            this.$router.push({ name: 'trainers' })
            return response
          })
          .catch(error => {
            this.isloading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Уведомление',
                icon: 'BellIcon',
                text: error.response.data.message,
                variant: 'danger',
              },
            })
          })
      } catch (e) {
        this.isloading = false
        console.error(e)
      }
    },
    debounceSearch(search, loading, fn) {
      clearTimeout(this.debounce)
      if (search.length > 0) {
        this.debounce = setTimeout(fn, 600)
      }
    },
    getKindsOfSport(search, loading) {
      this.debounceSearch(search, loading, async () => {
        try {
          await kind_of_sport_module.fetchItems({ filterText: search })
            .then(result => {
              this.sportOptions = result.data.rows
              loading(false)
            })
        } catch (e) {
          console.error(e)
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.select {
  padding: 21px;
  padding-top: 0px;
  width: 100%;
}
.label {
  padding-left: 21px;
}
.font-size {
  font-size: inherit;
}

img {
  height: 200px;
  width: 200px;
}

</style>
